import Carousel from "../util/Carousel";

export default {
  init() {
		new Carousel("slider-article", "article-box")
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    //carousel()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js